import React from "react";

type OnSearchChangePayload = {
  query: string;
  [key: string]: string | undefined;
};

export type HeaderContextProps = {
  onSearchChange?: (props: OnSearchChangePayload) => void;
};

export const HeaderContext = React.createContext<HeaderContextProps>({});
